import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { PropertyData, BObjectModel, QueovalItem, QueovalItemModel } from '../../../../models';
import { CoreService } from '../../../../services/core.service';
import { HttpService } from '../../../../services/dataAccess.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-image-select',
  templateUrl: './image-select.component.html',
  styleUrls: ['./image-select.component.css']
})

export class ImageSelectComponent implements OnInit {

  public valueSelected: string;
  public imageSelected: string;
  public identBo: string;

  @Input('input') input: PropertyData;
  @Input('model') model: BObjectModel;
  @Input('parent') parent: ElementRef;

  constructor(private http: HttpService, private indParam: CoreService) { }

  ngOnInit(): void {
    this.identBo = this.model.Body.SelectedGroupsList[0].ID;
    this.input.MainElementList[0].SelectOptionsList.forEach((itm: QueovalItem) => {
      if (itm.Selected) {
        this.valueSelected = `${itm.Value}`;
      }
    });
    this.getImage(this.valueSelected);
  }

  selectChange(selectedValue: any, selectItem: PropertyData): void {

    if (selectedValue && selectItem) {
      selectItem.MainElementList[0].SelectOptionsList.forEach((itm: QueovalItem) => {
        itm.Selected = itm.Value === selectedValue.value;
      });
    }
    this.getImage(selectedValue);

  }

  getImage(valueSelected: string): void {
    //this.http.getHttp<QueovalItemModel>(`${this.indParam.ConfigFile.apiUrl}api/queovalitem/getData/IMAGE/${valueSelected}|${this.identBo}`).subscribe((result: QueovalItemModel) => {
    this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/IMAGE/${valueSelected}|${this.identBo}`).subscribe((result: QueovalItemModel) => {
      this.imageSelected = result.queovalItemList[0].Value;
    });
  }
}
